import React, { useCallback, useEffect, useState } from "react";

import "../../../Assets/CSS/bulkorder.css";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import axios from "axios";
import moment from "moment";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";

function OMSParentOrder({ searchOrderId, overDueAgenstLoading = "", parent_order_id }) {
  
  const [loadingData, setLoadingData] = useState([]);
  const navigate = useNavigate();
  const [omsData, setOmsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [pageNumberLimit, setPageLimit] = useState(10);
  const [maxPageLimit, setMaxLimit] = useState(5);
  const [minPageLimit, setMinLimit] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const getOMSData = useCallback(async () => {
    if(!parent_order_id) {
      return null;
    }
    const url = `/api/oms/orders?page=${currentPage}&limit=${itemPerPage}&order_id=${searchOrderId}&decending_order=true&parent_order_id=${parent_order_id}`;

    try {
      setLoading(true);
      const { data } = await axios.get(url);
      if (data.status) {
        setTotalResults(data?.orders?.count);
        setOmsData(data?.orders?.rows);
      } else {
        setTotalResults(0);
        setOmsData([]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [page, currentPage, searchOrderId]);

  useEffect(() => {
    let token;
    if (searchOrderId) {
      clearTimeout(token);
      token = setTimeout(() => {
        getOMSData();
      }, 1000);
    } else {
      getOMSData();
    }
    return () => clearTimeout(token);
  }, [page, currentPage, searchOrderId]);

  const pages = [];
  const handleClick1 = (event) => {
    setCurrentPage(Number(event.target.id));
    setPage(Number(event.target.id));
  };
  for (let i = 1; i <= Math.ceil(totalResults / itemPerPage); i++) {
    pages.push(i);
  }
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItem = loadingData.results?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePrevBtn = (e) => {
    if (currentPage === pages[0]) {
      return;
    }
    setPage(currentPage - 1);
    setCurrentPage(currentPage - 1);
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxLimit(maxPageLimit - pageNumberLimit);
      setMinLimit(minPageLimit - pageNumberLimit);
    }
  };
  const handleNextBtn = (e) => {
    if (currentPage === pages.length) {
      return;
    }
    setPage(currentPage + 1);
    setCurrentPage(currentPage + 1);
    if (currentPage + 1 > maxPageLimit) {
      setMaxLimit(maxPageLimit + pageNumberLimit);
      setMinLimit(minPageLimit + pageNumberLimit);
    }
  };
  const renderPageNumbers = pages
    ? pages.map((number, index) => {
        if (number < maxPageLimit + 1 && number > minPageLimit) {
          return (
            <li
              key={index}
              className={
                currentPage === number ? "page-item active" : "page-item"
              }
              style={{ cursor: "pointer" }}
              onClick={(e) => handleClick1(e)}
            >
              <a
                href="#overview-page"
                className="page-link pb-2 ps-3 pt-2 pe-3"
                id={number}
              >
                {number}
              </a>
            </li>
          );
        } else return null;
      })
    : "";

  // ----------------------------- OverDue function ----------------------------
  function overDueCalculation(date) {
    const currentDate = new Date();
    // Calculate difference between two dates in milliseconds
    const differenceInMs = currentDate - date;
    // Convert milliseconds to days
    const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24);
    console.log(differenceInDays);
    if (differenceInDays >= 3 && differenceInDays < 7) return "#E8880C";
    if (differenceInDays >= 7 && differenceInDays <= 10) return "#36A206";
    if (differenceInDays > 10) return "#D22F4C";
    // else return "gray";
  }

  if(!parent_order_id) {
    return null;
  }

  return (
    <div className=" ms-0 ps-0 m-2 pt-0">
      <TableContainer className="overflow-x-scroll">
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead className="">
            <TableRow className="p-2 ">
              <TableCell align="center" className="" sx={{ bgcolor:'#e5e7eb'}}>
                Ordered Date
              </TableCell>
              <TableCell align="center" sx={{ bgcolor:'#e5e7eb'}}>Order ID</TableCell>
              <TableCell align="center" sx={{ bgcolor:'#e5e7eb'}}>Buyer Name</TableCell>
              <TableCell align="center" sx={{ bgcolor:'#e5e7eb'}}>Supplier Name</TableCell>
              <TableCell align="center" sx={{ bgcolor:'#e5e7eb'}}>Approval Status</TableCell>
              <TableCell align="center" sx={{ bgcolor:'#e5e7eb'}}>Buyer Paid Amount</TableCell>
              <TableCell align="center" sx={{ bgcolor:'#e5e7eb'}}>Supplier Paid Amount</TableCell>
              {overDueAgenstLoading !== "" ? (
                <TableCell>Supplier Loading Date</TableCell>
              ) : (
                ""
              )}

              <TableCell align="center" sx={{ bgcolor:'#e5e7eb'}}>Payment Status</TableCell>
              {/* <TableCell align="center" sx={{ bgcolor:'#e5e7eb'}}>Gross Margin</TableCell>
              <TableCell align="center" sx={{ bgcolor:'#e5e7eb'}}>Net Margin</TableCell> */}

              <TableCell align="center" sx={{ bgcolor:'#e5e7eb'}}>View</TableCell>
            </TableRow>
          </TableHead>
          {loading ? (
            <>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>
                <ClipLoader />
              </TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
            </>
          ) : (
            <TableBody>
              {omsData?.length === 0 ? (
                <>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell align="center">No Data Found</TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </>
              ) : (
                omsData?.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell align="center" style={{ width: "120px" }}>
                      {row?.ordered_date
                        ? moment(row?.ordered_date).format("DD-MM-YYYY")
                        : "NA"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.only_bnps?.order_id
                        ? row?.only_bnps?.order_id
                        : "NA"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.buyer_shop?.name ? row?.buyer_shop?.name : "NA"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.op_sourcing_details?.[0]?.firm_name
                        ? row?.op_sourcing_details?.[0]?.firm_name
                        : "NA"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.only_bnps?.ayekart_lvl1_status === "Approved" &&
                      row?.only_bnps?.ayekart_lvl2_status === "Approved"
                        ? "Approved"
                        : "Pending"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.only_bnps?.paid_amount
                        ? row?.only_bnps?.paid_amount
                        : "NA"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.only_bnps?.supplier_total_transfer_amt
                        ? row?.only_bnps?.supplier_total_transfer_amt
                        : "NA"}
                    </TableCell>
                    {overDueAgenstLoading !== "" ? (
                      <TableCell align="center">
                        {row?.only_bnps?.due_date ? (
                          <button
                            className="p-2"
                            disabled
                            style={{
                              backgroundColor: `${overDueCalculation(
                                row?.supplier_loading_time
                                  ? new Date(row?.supplier_loading_time)
                                  : new Date()
                              )}`,
                              color: "#fff",
                              borderRadius: "10px",
                            }}
                          >
                            {row?.supplier_loading_time
                              ? new Date(
                                  row?.supplier_loading_time
                                ).toLocaleDateString()
                              : "NA"}
                          </button>
                        ) : (
                          "NA"
                        )}
                      </TableCell>
                    ) : (
                      ""
                    )}
                    <TableCell align="center">
                      {row?.only_bnps?.collection_status
                        ? row?.only_bnps?.collection_status
                        : "NA"}
                    </TableCell>

                    {/* <TableCell align="center">
                      {(row?.only_bnps?.total_sp
                        ? parseFloat(row?.only_bnps?.total_sp)
                        : 0) - row?.only_bnps?.total_cp
                        ? parseFloat(row?.only_bnps?.total_cp)
                        : 0}
                    </TableCell>
                    <TableCell align="center">{"NA"}</TableCell> */}
                    <TableCell align="center">
                      <div>
                        <Button
                          variant="outlined"
                          onClick={() =>
                            navigate(`/oms/${row?.only_bnps?.order_id}`)
                          }
                        >
                          View
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          )}
        </Table>
        {omsData?.length !== 0 && (
          <div className="row mx-auto mt-3">
            <div className="col-sm-6 pt-2 d-flex justify-content-start">
              Showing {itemPerPage * currentPage - (itemPerPage - 1)} to{" "}
              {itemPerPage * currentPage > totalResults
                ? totalResults
                : itemPerPage * currentPage}{" "}
              entries of {totalResults ? totalResults : ""}
            </div>
            <div className="col-sm-6 d-flex justify-content-end">
              <ul className="pagination">
                <li className="page-item pt-1 pl-2 pr-2 border">
                  <a
                    href="#overview-page"
                    className={currentPage !== pages[0] ? "show" : "hideBtn"}
                    onClick={(e) => handlePrevBtn(e)}
                  >
                    Prev
                  </a>
                </li>
                {renderPageNumbers}
                <li className="page-item pt-1 pl-2 pr-2 border border-left-0">
                  <a
                    href="#overview-page"
                    className={
                      currentPage !== pages.length ? "show" : "hideBtn"
                    }
                    onClick={(e) => handleNextBtn(e)}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </div>
          </div>
        )}
      </TableContainer>
    </div>
  );
}

export default OMSParentOrder;
